module.exports = __webpack_public_path__ + "img/medication_new.8f9951d3.png";